export interface Category {
  id: number;
  name: string;
  namePl: string;
  url: string;
  imageSeq: string;
  icon: string;
}

export const categories: Category[] = [
  {
    id: 911,
    name: "Shoes",
    namePl: "Buty",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    imageSeq: "cat-shoes-01",
    icon: "ri-footprint-line",
  },
  {
    id: 912,
    name: "Hoodies/Sweaters",
    namePl: "Bluzy i Swetry",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    imageSeq: "cat-hoodies-02",
    icon: "ri-t-shirt-line",
  },
  {
    id: 913,
    name: "T-Shirts",
    namePl: "Koszulki",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    imageSeq: "cat-tshirts-03",
    icon: "ri-t-shirt-air-line",
  },
  {
    id: 914,
    name: "Jackets",
    namePl: "Kurtki",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    imageSeq: "cat-jackets-04",
    icon: "ri-shirt-line",
  },
  {
    id: 915,
    name: "Pants/Shorts",
    namePl: "Spodnie i Szorty",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    imageSeq: "cat-pants-05",
    icon: "ri-layout-line",
  },
  {
    id: 916,
    name: "Headwear",
    namePl: "Nakrycia Głowy",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    imageSeq: "cat-headwear-06",
    icon: "ri-emotion-line",
  },
  {
    id: 917,
    name: "Sets",
    namePl: "Komplety",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    imageSeq: "cat-sets-07",
    icon: "ri-stack-line",
  },
  {
    id: 918,
    name: "Underwear/Underpants",
    namePl: "Bielizna",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    imageSeq: "cat-underwear-08",
    icon: "ri-shirt-line",
  },
  {
    id: 919,
    name: "Jersey",
    namePl: "Koszulki Sportowe",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    imageSeq: "cat-jersey-09",
    icon: "ri-t-shirt-line",
  },
  {
    id: 920,
    name: "Accessories",
    namePl: "Akcesoria",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    imageSeq: "cat-accessories-10",
    icon: "ri-glasses-line",
  },
  {
    id: 921,
    name: "Bags",
    namePl: "Torby",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    imageSeq: "cat-bags-11",
    icon: "ri-briefcase-line",
  },
  {
    id: 922,
    name: "Belts",
    namePl: "Paski",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    imageSeq: "cat-belts-12",
    icon: "ri-link",
  },
  {
    id: 923,
    name: "Perfumes",
    namePl: "Perfumy",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    imageSeq: "cat-perfumes-13",
    icon: "ri-drop-line",
  },
  {
    id: 924,
    name: "OtherStuff",
    namePl: "Inne Produkty",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    imageSeq: "cat-other-14",
    icon: "ri-more-line",
  },
];

export const categoryGroups = {
  clothing: categories.filter(c => [913, 915, 916, 917].includes(c.id)),
  accessories: categories.filter(c => [918, 919, 920, 921].includes(c.id)),
  other: categories.filter(c => [922, 923, 924].includes(c.id)),
};